import { getMainPhoto } from '../utils/composite';
// src/components/ComponentPickerSheet.jsx
// Модалка выбора компонента для составного товара.
// Получает список доступных продуктов (исключая текущий редактируемый и уже добавленные).
// При клике на товар вызывает onPick(product).

import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

export default function ComponentPickerSheet({ allProducts, excludeIds = [], onPick, onClose }) {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  const candidates = useMemo(() => {
    const exc = new Set(excludeIds);
    let list = allProducts.filter(p => !exc.has(p.id));
    if (search.trim()) {
      const q = search.trim().toLowerCase();
      list = list.filter(p =>
        (p.name || '').toLowerCase().includes(q)
        || (p.article || '').toLowerCase().includes(q)
      );
    }
    return list.slice(0, 100);
  }, [allProducts, excludeIds, search]);

  return (
    <div className="modal-backdrop" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-sheet" style={{ maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
        <div className="modal-header">
          <p className="modal-title">{t('products.pickComponent')}</p>
          <button className="modal-close" onClick={onClose}><Icon name="x" size={16} /></button>
        </div>

        <div style={{ marginBottom: 12 }}>
          <input
            className="input"
            placeholder={t('products.searchProduct')}
            value={search}
            onChange={e => setSearch(e.target.value)}
            autoFocus
          />
        </div>

        <div style={{ overflowY: 'auto', flex: 1, marginRight: -8, paddingRight: 8 }}>
          {candidates.length === 0 ? (
            <div className="empty-state">
              <p>{search ? t('products.noProductsFound') : t('products.noProductsForComponents')}</p>
            </div>
          ) : (
            candidates.map(p => (
              <div
                key={p.id}
                onClick={() => onPick(p)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  padding: '10px 12px', borderRadius: 'var(--r-sm)',
                  cursor: 'pointer', marginBottom: 4,
                  background: 'var(--bg-elevated)',
                  border: '1px solid var(--border)',
                }}
              >
                {getMainPhoto(p) ? (
                  <img src={getMainPhoto(p)} alt="" style={{ width: 36, height: 36, borderRadius: 'var(--r-xs)', objectFit: 'cover', flexShrink: 0 }} />
                ) : (
                  <div style={{
                    width: 36, height: 36, borderRadius: 'var(--r-xs)',
                    background: 'var(--bg-subtle)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    color: 'var(--fg-faint)', flexShrink: 0,
                  }}>
                    <Icon name="package" size={16} />
                  </div>
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontSize: 14, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {p.name}
                  </p>
                  <p style={{ fontSize: 11, color: 'var(--fg-muted)', marginTop: 2 }}>
                    {p.unit} · {p.stock != null ? p.stock : '—'}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
